import * as React  from "react";
import { useState, useRef } from 'react'
import axios from 'axios';

const ModalInterviewCancel = (props) => {
  const buttonEl = useRef(null);

  function cancelLink(d_interview_detail_id, m_patient_id) {
    if (!(window.confirm('本当に紐づけを解除しますか？'))) {
      return null;
    }
    axios.patch(
      '/api/internal/patients/cancel_link', {
        d_interview_detail_id: d_interview_detail_id,
        m_patient_id: m_patient_id
      })
      .then(function (response) {
        // モーダルを消す
        buttonEl.current.click();
        // defaultIndexPropsの修正
        const i = props.defaultIndexProps.findIndex(({id}) => id === response.data.d_interview_detail_id);
        props.defaultIndexProps[i].status = 1;
        props.defaultIndexProps[i].kanzyano = "";
        props.defaultIndexProps[i].m_patient_id = null;
        props.defaultIndexProps[i].patient_name = "";
        props.defaultIndexProps[i].mobile_phone_number = "";
        props.defaultIndexProps[i].address = "";
        props.defaultIndexProps[i].nupdatef = 0;
        props.defaultIndexProps[i].bupdatef = 0;
        props.updateIndexProps(props.defaultIndexProps);
      })
      .catch(error => {
        console.log(error.response);
      });
  }

  return (
    <>
      <div id="modalInterviewCancel" className="modal fade" data-backdrop="static" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" ref={buttonEl}>&times;</button>
            <h4 className="modal-title">{props.name}　様の紐づけ内容</h4>
          </div>
          <div className="modal-body">
            <table className="table table-bordered table-noborder">
              <thead className="interview-table-head">
                <tr>
                  <th colSpan={3}>紐づけされている患者情報</th>
                </tr>
              </thead>
              <tbody className="interview-table">
                <tr>
                  <td className="col-md-3 col-sm-3 col-xs-3">
                    患者番号
                  </td>
                  <td className="col-md-8 col-sm-8 col-xs-8">
                    {props.kanzyano}
                  </td>
                </tr>

                <tr>
                  <td className="col-md-3 col-sm-3 col-xs-3">
                    患者名
                  </td>
                  <td className="col-md-8 col-sm-8 col-xs-8">
                    {props.name}
                  </td>
                </tr>

                <tr>
                  <td className="col-md-3 col-sm-3 col-xs-3">
                    生年月日
                  </td>
                  <td className="col-md-8 col-sm-8 col-xs-8">
                    {props.birthday}
                  </td>
                </tr>

                <tr>
                  <td className="col-md-3 col-sm-3 col-xs-3">
                    携帯電話番号
                  </td>
                  <td className="col-md-8 col-sm-8 col-xs-8">
                    {props.mobile_phone_number}
                  </td>
                </tr>

                <tr>
                  <td className="col-md-3 col-sm-3 col-xs-3">
                    住所
                  </td>
                  <td className="col-md-8 col-sm-8 col-xs-8">
                    {props.address}
                  </td>
                </tr>

              </tbody>
            </table>
            <div className="form-group text-center">
              <input
                type="button"
                className="interview-link-modal-button"
                value="紐づけの解除"
                onClick={() => cancelLink(props.d_interview_detail_id, props.id)}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-default" data-dismiss="modal">閉じる</button>
          </div>
        </div>
      </div>  
    </div>
    </>
  )
}

export default ModalInterviewCancel
